/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface ConversationGroupModel {
  id: string;
  user_id: string;
  title: string | null;
  closed: boolean | null;
  latest_nori_conversation_id: string | null;
  has_visit: boolean;
  has_unread: boolean;
}
